/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
import React from "react";
import {
  SwipeableDrawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import { AssestsIcon, IconColors } from "../../Constants/AssetsConstants";
import Icon from "./CustomIcon";

function RightSideMenuComponent({
  openDrawer,
  handleopenDrawer,
  handleManageMeters,
  openManageMeters,
}) {
  const menuItems = [
    {
      text: "Project",
      icon: AssestsIcon.ICON_PROFILE,
    },
    {
      text: "Manage Meters",
      icon: AssestsIcon.ICON_MAGAGEMETER,
      onClick: () => handleManageMeters(),
    },
    {
      text: "Bill History",
      icon: AssestsIcon.ICON_BILLHISTORY,
    },
    {
      text: "Settings",
      icon: AssestsIcon.ICON_SETTINGS,
    },
    {
      text: "Help / FAQ",
      icon: AssestsIcon.ICON_FAQ,
    },
    {
      text: "logout",
      icon: AssestsIcon.ICON_LOGOUT,
      logout: true,
    },
  ];

  return (
    <SwipeableDrawer
      anchor="right"
      open={!openManageMeters && openDrawer}
      onClose={handleopenDrawer}
      onOpen={handleopenDrawer}
      PaperProps={{
        style: { backgroundColor: "#e3fff5" },
      }}
    >
      <Box
        sx={{
          width: 200,

          paddingTop: "65px",
        }}
        role="presentation"
      >
        <div className="profile-header-container">
          <p className="profile-name">Hello, BHASKER</p>
          <div className="d-flex align-items-center ">
            <Icon icon={AssestsIcon.ICON_BUILDING} color={IconColors.ICON_LIGHT_GRAY} size={12} />
            <p className="profile-detail-text">
              Building ID: <b>B1075-40</b>{" "}
            </p>
          </div>
          <div className="d-flex align-items-center">
            <Icon icon={AssestsIcon.ICON_BUILDING} color={IconColors.ICON_LIGHT_GRAY} size={12} />
            <p className="profile-detail-text">
              Customer ID: <b>A106-75B</b>{" "}
            </p>
          </div>
        </div>
        <List>
          {menuItems.map((item, index) => (
            <ListItemButton
              className="Rightsidemenu-list-item-container"
              key={index}
              onClick={item.onClick}
            >
              <ListItemIcon className="Rightsidemenu-list-item-icon">
                <Icon
                  icon={item.icon}
                  size={18}
                  color={item.logout ? IconColors.ICON_RED : IconColors.ICON_GRAY}
                />
              </ListItemIcon>

              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontFamily: "PoppinsRegular",
                  color: item.logout ? "#dd2020" : "#007048",
                  fontSize: "1rem",
                  textAlign: "left",
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </SwipeableDrawer>
  );
}

export default RightSideMenuComponent;
